import gql from 'graphql-tag';


export const SUBMIT_MANUAL_TIMESHEET = gql`
  mutation SubmitManualTimesheet($timesheetId: String!,$regularApproval:Boolean!,$user:String) {
    submitManualTimesheet(input: { timesheetId: $timesheetId,regularApproval:$regularApproval,user:$user })
  }
`;
